import React from 'react';
import styled from 'styled-components';
import { Dialog as TDialog } from 'tdesign-react';
import BoardPanel from '@/components/Cluster/BoardPanel';
import { getTenantChartData } from '@/services/tenantService';
import ModalHeader from '@/components/Header/Modal';

export default function Dashboard({ detail, clusterName, handleClose, visible }) {
  const onClose = () => {
    handleClose();
  };

  return (
    <Dialog
      header={<ModalHeader tags={[clusterName, detail.tenant]}>监控-租户</ModalHeader>}
      width='90%'
      placement='center'
      footer={null}
      onClose={onClose}
      onOverlayClick={onClose}
      visible={visible}
    >
      <Body>
        {visible && (
          <BoardPanel
            getChartsData={async (params) =>
              await getTenantChartData({
                clusterName,
                tenant: detail.tenant,
                ...params,
              })
            }
          />
        )}
      </Body>
    </Dialog>
  );
}

const Body = styled.div`
  background-color: #f7f8fa;
  margin: 0px -32px -48px;
  padding: 0 32px 30px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  box-shadow: 0px -1px 0px #e7e7e7;
`;

const Dialog = styled(TDialog)`
  .t-dialog {
    padding-top: 18px;
  }
  .t-dialog__body {
    padding-top: 18px;
    overflow: visible;
  }
`;
